<template>
    <div class="complaints">
        <h2>Постановка синдромального диагноза</h2>
        <h4>Заболевание</h4>
        <div v-for="(item, key) in getDiagnostic.syndromic" :key="key" class="item-combo">
            <div class="item-combo__flex">
                <v-autocomplete
                    :readonly="getFlagReadonly"
                    label=""
                    outlined
                    height="46"
                    hide-details
                    :disabled="!item.isVisible"
                    :items="getSelectList(item)"
                    @change="save({
                        obj: item,
                        url: 'DiaTest/AddOrUpdateDiagnose',
                        index: key,
                        nameGroup: 'diagnostic',
                        nameProperty: 'syndromic'
                    })"
                    @focus="updateSelectList(item)"
                    item-text="name"
                    item-value="id"
                    class="item-combo__select"
                    v-model="item.diagnoseId"
                    :loading="getDiagnostic.mkbList.length === 0"
                />

                <v-btn v-if="item.testDataType === 3 && !getFlagReadonly" title="Удалить" color="error" @click.prevent="deleteDiag(item, key)" large>
                    <v-icon color="white">mdi-delete</v-icon>
                </v-btn>

                <v-btn :loading="item.loadReturn" v-if="item.testDataType === 2" title="Вернуть к исходному состоянию" @click.prevent="returnInitianState(item, key)" color="info" large>
                    <v-icon color="white">mdi-restore</v-icon>
                </v-btn>

                <v-btn :loading="item.loadViewOrNot" title="Скрыть" v-if="item.testDataType === 1 && !getFlagReadonly" @click.prevent="viewOrNot(item, key)" color="info" large>
                    <v-icon color="white">
                        {{ item.isVisible ? 'mdi-eye-off' : 'mdi-eye' }}
                    </v-icon>
                </v-btn>

            </div>
        </div>
        <button
            v-if="!getFlagReadonly"
            @click="addDiagnose({ type: 1, name: 'syndromic' })"
            type="button"
            class="custom-button"
            :disabled="addDisabled()"
            :class="{ 'btn-disabled': addDisabled() }">
            + Добавить
        </button>

        <TimeoutSnackbar :options="snackbar" />
    </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import TimeoutSnackbar from '@/components/TimeoutSnackbar.vue';

export default {
    name: 'Syndromic',
    components: { TimeoutSnackbar },
    props: {
        name: String
    },
    computed: {
        ...mapGetters({
            getDiagnostic: 'createDiagnosticTest/getDiagnostic',
            getFlagReadonly: 'createDiagnosticTest/getFlagReadonly'
        })
    },
    data() {
        return {
            snackbar: {
                show: false,
                text: null,
                color: null,
                timeout: -1
            },
            itemsMkb: []
        }
    },
    methods: {
        ...mapActions({
            getSyndromDiagnoses: 'createDiagnosticTest/getSyndromDiagnoses',
            getDataDiagnoses: 'createDiagnosticTest/getDataDiagnoses',
            saveInline: 'createDiagnosticTest/saveInline',
            deleteDiagnose: 'createDiagnosticTest/deleteDiagnose',
            resetValue: 'createDiagnosticTest/resetValue'
        }),
        ...mapMutations({
            changeFlagMissingStep: 'createDiagnosticTest/changeFlagMissingStep',
            addDiagnose: 'createDiagnosticTest/addDiagnose'
        }),
        getSelectList(item) {
            return item.selectList && item.selectList.length > 0 ? item.selectList : this.getDiagnostic.mkbList;
        },
        updateSelectList(item) {
            let existingIds = this.getDiagnostic.syndromic.map(x => x.diagnoseId);

            let selectList = this.getDiagnostic.mkbList.filter(x => {
                return existingIds.find(y => y === x.id) === undefined || x.id === item.diagnoseId;
            });

            this.$set(item, 'selectList', selectList);
        },
        addDisabled() {
            if (this.getDiagnostic.syndromic.length === 0) {
                return false;
            }

            let index = this.getDiagnostic.syndromic.length - 1;
            let last = this.getDiagnostic.syndromic[index];
            return last.diagnoseId === null;
        },
        save(obj) {
            if(obj.obj.diagnoseId) {
                obj.obj.diagnoseName = this.getDiagnostic.mkbList.find((f) => f.id === obj.obj.diagnoseId).name
            }

            obj.obj.selectList = [];

            this.saveInline(obj)
            .then(() => {
                this.snackbar = { text: 'Изменения сохранены успешно!', color: 'success', timeout: 3000, show: true };
            })
            .catch((error) => {
                if(error) {
                    this.snackbar = { text: 'Ошибка сохранения данных, обратитесь к Администратору!', color: 'error', timeout: 3000, show: true };
                }
            })
        },
        deleteDiag(item, key) {
            if(confirm('Вы уверены, что хотите удалить диагноз ?')) {
                this.deleteDiagnose({ item, key, diagnoseType: 1, testId: this.$route.params.id });
            }
        },
        viewOrNot(item, key) {
            item.loadViewOrNot = true;

            this.saveInline({ obj: { ...item, isVisible: !item.isVisible, testDataType: item.testDataType === 1 ? 2 : item.testDataType }, url: 'DiaTest/AddOrUpdateDiagnose', index: key, nameGroup: 'diagnostic', nameProperty: 'syndromic' })
                .then(() => {
                    item.loadViewOrNot = false;
                })
        },
        returnInitianState(item, key) {
            item.loadReturn = true;

            this.resetValue({ item, levelDeep: 1, url: 'ResetDiagnose', index: key, nameGroup: 'diagnostic', nameProperty: 'syndromic', testId: this.$route.params.id })
                .then(() => {
                    item.loadReturn = false;
                })
        }
    },
    created() {
        // Если предыдущая нумерация пропущена и у этой нумерации состояние 1/3 то вызываем окно с подтверждением
        if(this.getDiagnostic.methods === 'skip' && this.getDiagnostic.levels[6].visibleType !== 2) {
            this.changeFlagMissingStep({ flag: true, index: 6 });
        } else {
            this.getSyndromDiagnoses();
            this.getDataDiagnoses({ testId: this.$route.params.id, diagnoseType: 1 })
                .then((res) => {
                    if(res.length === 0) this.addDiagnose({ type: 1, name: 'syndromic' });
                })
        }
    }
}
</script>
